import { Button, FilterCommon, Modal, Pagination, Tabs } from "@/components";
import { ANNUAL_LEAVE_TABS, ANNUAL_TAB_OVERVIEW, PAGE_DEFAULT } from "@/utils";
import AnnualLeaveOverview from "./components/AnnualLeaveOverview/AnnualLeaveOverview.vue";
import BonusLeave from "./components/BonusLeave/BonusLeave.vue";
import GeneralConfiguration from "./components/GeneralConfiguration/GeneralConfiguration.vue";
import LeaveCarryover from "./components/LeaveCarryover/LeaveCarryover.vue";
import { mapState } from "vuex";
import ProjectLeave from "./components/ProjectLeave/ProjectLeave.vue";

export default {
  name: "LeaveManagement",
  components: {
    FilterCommon,
    Button,
    Pagination,
    Modal,
    Tabs,
    AnnualLeaveOverview,
    BonusLeave,
    GeneralConfiguration,
    LeaveCarryover,
    ProjectLeave,
  },
  data() {
    return {
      dataFilterDefault: {},
      loading: false,
      pages: PAGE_DEFAULT,
      visibleModal: false,
      recordSelected: null,
      activeTab: localStorage.getItem("activeTab") ?? ANNUAL_TAB_OVERVIEW,
      ANNUAL_TAB_OVERVIEW,
      ANNUAL_LEAVE_TABS,
      annualLeaveTabs: [],
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    const { roles } = this.userInfo;
    this.annualLeaveTabs = ANNUAL_LEAVE_TABS.filter((tab) => roles.find((role) => tab.roles.includes(role)));
  },
  methods: {
    handleChangeTab(key) {
      this.activeTab = key;
      localStorage.setItem("activeTab", key);
    },
  },
};
